import { useEffect, useState } from "react";
import { getPrincipalMessage } from "../Service/Api";
import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";
const removeHtmlTags = (str) => {
  return str.replace(/<[^>]*>/g, ""); // Removes anything between '<' and '>'
};
const PrincipalDesk = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      setData(messages);
    };
    fetchData();
  }, []);
  const emptyArray = [
    // { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "director.jpg" },
  ];
  return (
    <>
      <Breadcrumb
        breadtitle="Principal Message"
        breadmid="About"
        breadend="Principal Message"
      />
      <div className="innerpage">
        <div className="container">
          {data?.length > 0 ? (
            data
              ?.filter((div) => div.category === "Principal")
              .map((item, index) => (
                <div className="row message_inner" key={index}>
                  <div className="col-lg-4 col-md-4">
                    <LazyLoad>
                      <img
                        src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`}
                        className="inner_img img-fluid"
                        alt="Cannosa School, Lucknow"
                      />
                    </LazyLoad>
                  </div>
                  <div className="col-lg-8 col-md-8 messagebox">
                  <p dangerouslySetInnerHTML={{ __html: item.message }} />
                    <h5 className="mb-0">{item.name} </h5>
                    <h5>
                      <span> {item.category} </span>
                    </h5>
                    <div className="clr"></div>
                  </div>
                </div>
              ))
          ) : (
            <div className="row">
              <div className="row message_inner">
                <div className="col-lg-4 col-md-4">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/principal.png"
                      className="inner_img img-fluid"
                      alt="Canossa School, Lucknow"
                    />
                  </LazyLoad>
                </div>
                <div className="col-lg-8 col-md-8 messagebox">
                  <p>
                    “Those who do not burn with love cannot start a fire” St.
                    Magdalene of Canossa.
                  </p>
                  <p>
                    <b></b>“Education is not so much the feeding of facts into
                    the mind as the awakening of curiosity in the soul.”
                  </p>
                  <p>
                    Dear students, parents and staff members a warm welcome to
                    all of you as we embark on a new academic year 2025-26 at
                    Canossa School. It is an honour to lead this institution
                    where we strive to nurture young minds and shape them into
                    responsible and compassionate global citizens. Our vision is
                    to provide a holistic learning environment that fosters
                    academic excellence and formation of character. We have a
                    team of dedicated teaching staff committed to the welfare of
                    the children in our care. For us teaching is a passion and a
                    calling. The importance of instilling moral values in our
                    students is our prime objective. So we try to hone the
                    talents of our children in a manner that they reach up to
                    their optimal potential. For the past few years our students
                    have excelled in the academic field as we have scored cent
                    percentage result in the board exams.
                  </p>
                  <p>
                    We have introduced new initiatives in the field of
                    technologies like AI, Robotics, advanced smart classes and
                    we have equipped with various well furnished labs for
                    various subjects. We have availed various sports facilities
                    for the physical well being of the students. Our aim
                    importantly is to make education a fun filled enjoyable
                    learning and growing experience on the solid foundation of
                    values.
                  </p>
                  <p>
                    As we are in the new academic year lets renew our commitment
                    to fostering a positive and inclusive school community. Your
                    involvement and support means a lot for us. We are committed
                    to provide a safe supportive and challenging educational
                    environment.
                  </p>
                  <p>
                    Dear well wishers we have the responsibility to make
                    education more applicable to daily life situations, help
                    students to develop a deeper understanding of their personal
                    aims, achievements and thus to success in their future
                    careers.
                  </p>
                  <h5 className="mb-0">Sr Rosy MP </h5>
                  <h5>
                    <span>Principal</span>
                  </h5>
                  <div className="clr"></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PrincipalDesk;
